import PageHero from "../components/PageHero";
import GalleryGrid from "../components/GalleryGrid";

export default function Mireasa() {
  const IMAGINI = [1, 2, 3, 4, 5].map((n) => `/images/mirese/${n}.png`);

  return (
    <section>
      <PageHero
        title="Rochii de mireasă"
        subtitle="Silhouette personalizată, materiale premium și detalii couture."
      />
      <p className="mb-6">
        Lucrăm la comandă, pe măsuri, de la schiță la probă finală. Programările se fac cu minim 8–12 săptămâni înainte.
      </p>

      <GalleryGrid items={IMAGINI} />
    </section>
  );
}
